module.exports = __webpack_public_path__ + "img/hefei.867fbc5c.png";